module.exports = __webpack_public_path__ + "img/person-insights.cac79869.svg";